import React from 'react';
import clsx from 'clsx';

interface ModalBodyProps {
  children: React.ReactNode;
  className?: string;
  padded?: boolean;
  scrollable?: boolean;
}

export function ModalBody({
  children,
  className,
  padded = true,
  scrollable = false,
}: ModalBodyProps) {
  return (
    <div
      className={clsx(
        padded && 'modal-body',
        scrollable && 'max-h-[60vh] overflow-y-auto',
        className,
      )}
    >
      {children}
    </div>
  );
}
